"use client"

import { ttFirsNeue } from "@/fonts"
import useWindowDimensions from "@/hooks/useWindowDimensions"
import ArrowLeftIcon from "@/icons/arrowLeft"
import { cn } from "@/lib/utils"
import Image from "next/image"
import { useRouter } from "next/navigation"
import React from "react"

type Props = {}

const BannerDisclosure = (props: Props) => {
  const { width } = useWindowDimensions()

  const router = useRouter()

  return (
    <div className="relative w-full">
      {width && width < 640 ? (
        <Image
          src={"/images/news2.png"}
          alt="news"
          width={1400}
          height={400}
          className="object-cover w-full h-full"
        />
      ) : (
        <Image
          src={"/images/news.png"}
          alt="news"
          width={1400}
          height={400}
          className="object-cover w-full h-full"
        />
      )}
      <button
        className="bg-[#262626] flex items-center justify-between py-2 px-4 gap-4 rounded-full max-h-9 absolute top-3 md:top-6 left-3 md:left-6 uppercase font-normal text-xs"
        onClick={() => router.push("/")}
      >
        <ArrowLeftIcon />
        <div
          className={cn(
            "text-[10px] md:text-sm font-medium text-white mt-0.5",
            ttFirsNeue.className
          )}
        >
          Go back
        </div>
      </button>
      <div
        className={cn(
          "text-woodsmoke text-4xl font-medium absolute bottom-3 md:bottom-6 left-3 md:left-6",
          ttFirsNeue.className
        )}
      >{`Disclosure`}</div>
    </div>
  )
}

export default BannerDisclosure
